import { pb } from "./pocketbase";

export async function searchStudents(query) {
  if (!query) {
    return [];
  }

  const performSearch = async (filter) => {
    const studentsList = await pb.collection('students').getList(1, 10, {
      filter: filter,
    });

    // Use a for...of loop for robustness. If one contract search fails,
    // it won't crash the entire student search.
    for (const student of studentsList.items) {
      try {
        const contractsList = await pb.collection('contracts').getList(1, 1, {
          filter: `student_id = "${student.id}"`,
          sort: '-created',
          expand: 'company_id',
        });
        student.contract = contractsList.items.length > 0 ? contractsList.items[0] : null;
      } catch (e) {
        console.error(`Failed to fetch contract for student ${student.id}:`, e);
        student.contract = null; // Ensure student is returned even if contract fetch fails
      }
    }

    return studentsList.items;
  };

  // Fonction helper pour construire le filtre multi-termes
  const buildMultiTermFilter = (searchQuery, includeId = false) => {
    const searchTerms = searchQuery.trim().split(/\s+/).filter(term => term.length > 0);
    const termFilters = searchTerms.map(term => {
      const termLower = term.toLowerCase();
      const termCapitalized = termLower.charAt(0).toUpperCase() + termLower.slice(1);
      return `(email ~ "${termLower}" || first_name ~ "${termLower}" || first_name ~ "${termCapitalized}" || last_name ~ "${termLower}" || last_name ~ "${termCapitalized}")`;
    });
    const baseFilter = termFilters.join(' && ');
    return includeId ? `(id = "${searchQuery}" || ${baseFilter})` : baseFilter;
  };

  try {
    const filter = buildMultiTermFilter(query, true);
    return await performSearch(filter);
  } catch (error) {
    if (error.data?.data?.id?.code === 'validation_invalid_format' || error.status === 400) {
        try {
            const filter = buildMultiTermFilter(query, false);
            return await performSearch(filter);
        } catch (e) {
            console.error("Failed to search students (fallback):", e);
            return [];
        }
    }
    console.error("Failed to search students:", error);
    return [];
  }
}
